const POWERS = {
  powerMin: [20, 40, 60, 80, 100, 120, 150, 200],
  powerMax: [220, 240, 260, 280, 300, 350, 400, 450, 500, 550, 600],
};
export default POWERS;
